import { render } from "./CodeBlockFolder.vue?vue&type=template&id=010de6cd&ts=true"
import script from "./CodeBlockFolder.vue?vue&type=script&lang=ts"
export * from "./CodeBlockFolder.vue?vue&type=script&lang=ts"

import "./CodeBlockFolder.vue?vue&type=style&index=0&id=010de6cd&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__